// DS: i10.11
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const YouTube: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M9.357 14.972c2.1-1.09 4.18-2.168 6.296-3.264L9.357 8.423v6.55zM2 13.512v-3.229c.008-.05.021-.102.024-.153.024-.395.04-.791.07-1.185.058-.683.122-1.37.353-2.019.31-.87.925-1.422 1.834-1.613.369-.078.75-.11 1.129-.13 1.323-.068 2.644-.152 3.967-.171 1.771-.026 3.545-.003 5.316.009 1.499.01 2.994.084 4.487.23 1.121.11 2.04.845 2.277 1.926.137.63.237 1.277.28 1.922a41.13 41.13 0 0 1-.019 5.803c-.05.668-.118 1.337-.348 1.973-.312.866-.928 1.417-1.835 1.61a6.26 6.26 0 0 1-1.004.118c-1.363.07-2.727.159-4.093.181-1.772.027-3.543.003-5.317-.009a49.211 49.211 0 0 1-4.486-.23c-1.168-.115-2.084-.894-2.3-2.052-.126-.677-.192-1.366-.273-2.05-.038-.309-.042-.62-.062-.93z" />
      </g>
    </svg>
  </IconWrap>
);
YouTube.displayName = 'YouTube';

export default YouTube;
